<template>
  <div class="introduceOne" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <!--导航-->
      <div class="z_nav">
        <div class="m_nav">
          <div class="m_nav_r">
            <ul>
             <!-- <li @click="topOne" :class="{active: 0<= scrollTop < 1105}"><a>極草，在澳門</a></li>
              <li @click="topTwo" :class="{active:1105 <= scrollTop < 2660}"><a>寸草知我心</a></li>
              <li @click="topThree" :class="{active:2660 <= scrollTop}"><a>極草和他的德國夥伴</a></li>
           -->
              <li v-for=" ( item , index ) in nav"
                  :key="item.id"
                  @click="selectMenu(index,$event)"
                  :class="{active:currentIndex == index}">
                <a>{{item}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!--content-->
      <div class="z_zt" ref="z_zt">
        <div class="comWidth heightTOP bankuanOne">
          <div class="z_zt_1">
            <h3>極草·5X冬蟲夏草純粉片，<br>這一凝結著多項國家發明專利的產品，<br>開創了冬蟲夏草高效利用時代</h3>
            <br>
            <p>
              <span>2004年，</span>
              <span>在青藏高原，冬蟲夏草深加工高效利用項目啓動。</span>
            </p>
            <p>
              <span>2008年，</span>
              <span>極草·5X冬蟲夏草純粉片產品誕生。<br> 依託自身強大的研發實力、國內外數個研發平臺、百餘項發明專利和實用新型技術，極草·5X冬蟲夏草純粉片成為冬蟲夏草物理加工領域最高科技成果，為冬蟲夏草整個產業帶來了劃時代的變革！</span>
            </p>
            <p>
              <span>2009年，</span>
              <span>極草·5X冬蟲夏草純粉片在中國內地上市。<br> 冬蟲夏草含著吃的高效、便利，使極草·5X冬蟲夏草純粉片得到了廣大消費者的高度認可，不僅在中國內地，在港澳臺、東南亞、日本、韓國，乃至歐美國家的也有眾多消費者開始使用極草，從輔助治療、到維護健康、提升生命品質的滋補保健，也有更多消費者將極草作為禮品、將自身的獲益傳遞給親朋好友、商業夥伴。</span>
            </p>
            <p>
              <span>现在，</span>
              <span>極草·5X冬蟲夏草純粉片的發明者將產品專利、品牌授權予澳門極草，並向澳門極草提供技術支持、品控指導。</span>
            </p>
            <p>
              <span></span>
              <span>經澳門政府批准，極草·5X冬蟲夏草純粉片在澳門正式投產。</span>
            </p>
            <!-- <p>
                        <span style="width: 74px;">2017年，</span>
                        <span style="width: 784px;">經澳門政府批准，極草冬蟲夏草純粉片在澳門正式投產。</span>
                    </p> -->
          </div>
          <img src="../../assets/advertisement/zt1-pic1.jpg" alt="">
          <div class="c_ztbox"></div>
          <div class="comWidth">
            <div class="z_zt_2" style="flex-wrap: wrap">
              <img src="../../assets/advertisement/zt1-pic2.jpg" alt="">
              <div>
                <h3>不忘初心，堅守如一</h3>
                <p>冬蟲夏草，只生長在青藏高原海拔3500米以上的酷寒雪域，這裡，是被稱為古地中海的地球第三極......</p>
                <p>
                  真菌、動物合一的獨特生長代謝方式，形成多種有特殊功效的藥用成分：陰陽同補，治諸虛百損，秘精益氣，專補命門，老少病虛者皆宜食用......
                </p>
                <p>
                  嚴寒冰雪環境中的神奇生命，只能在低溫環境下生存，超過20℃就不能正常生長。時至今日，仍然無法實現人工培育，只能依靠自然之力生長......
                </p> <br>
                <p>從初始，到今天，到未來……</p>
                <p style="display: flex">
                  <span>我們堅守的始終是：</span>
                  <span>
                        給消費者提供安全、放心、物超所值的冬蟲夏草<br>
                        讓消費者真實體驗到冬蟲夏草功效帶來的益處<br>
                        與消費者共享全面的信息，以保障消費者的自主選擇權益
                        </span>
                </p>
              </div>
            </div>
          </div>
          <div class="c_ztbox"></div>
        </div>
        <div class="comWidth heightTOP bankuanTwo">
          <div class="z_zt_3">
            <img src="../../assets/advertisement/zt1-pic3.jpg" alt="">
          </div>
          <div class="c_ztbox"></div>
        </div>
        <div class="comWidth heightTOP bankuanThree">
          <div class="z_zt_4">
            <div>
              <div class="z_4">
                <h3>
                  這一群相互敬重的人<br>
                  —— ——極草和他的德國夥伴 <br>
                  <small>原載《鳳凰週刊》2012年8月刊</small> <br>
                </h3>
                <div class="img-box">
                  <div>
                    <img style="" src="../../assets/advertisement/zt1-pic4.jpg" alt="">
                    <p>
                      S+S雙仕集團管理層
                    </p>
                  </div>
                  <div>
                    <img src="../../assets/advertisement/zt2-pic14.jpg" alt="">
                    <p>
                      世界壓片機行業領導品牌德國菲特公司授予極草總設計師張雪峰先生「榮譽工程師」
                    </p>
                  </div>
                </div>
              </div>
              <div class="clearBoth"></div>
              <br><br><br>
              <p>曾經有人說過，企業追求產品品質，最值得學習的就是德國企業，「德國造」是令人信賴的代名詞，而中國這個「世界工廠」，正在力求由「中國製造」向「中國創造」轉型，在這個過程中，學習德國精神裡的執著、嚴謹將是非常重要的一個元素。</p>
              <p>
                德國菲特，國際公認的高端壓片機製造龍頭；雙仕公司，世界一流金屬檢測機企業。 這兩家在全球範圍內都首屈一指的公司，卻異口同聲說與中國極草這個品牌的合作是他們的榮幸，而極草也把他們視作自己非常值得敬重的夥伴。
              </p>
              <br><br><br>
              <div class="clearBoth"></div>
              <div>
                <h5 class="c-small-title">世界難題？攻克！</h5>
                <p>
                  2006 年的一天，德國菲特公司來了一個叫張雪峰的中國客戶。他要求把帶來的一種“冬蟲夏草粉”壓片成型，這對於菲特來說自然是小菜一碟，但這個中國人說出了一個當時令全世界壓片機廠商都認為匪夷所思的要求：不添加任何輔料。在此之前，他已走遍國內及美日意等地眾多知名壓片機廠，但他收穫到的都是“不可能”這三個字，菲特的人員遺憾的告訴他，菲特也沒有攻克這個難關。
                </p>
                <p>
                  張雪峰沒有絕望，還是努力的遊說著菲特的工程師們，希望他們能夠努力嘗試。菲特一位元老工程師好奇的問他，“你為什麼一定要做純粉片呢？”張雪峰似乎一下來了勁，他向菲特展示了他的研究成果，原來他發明了冬蟲夏草細胞級微粉，能夠使冬蟲夏草這種不可人工培育的珍稀資源利用率大大提高。他瞭解到做成含片不僅方便，而且通過口腔黏膜吸收效果比腸胃吸收要更好，所以他想將他的發明進一步製成含片。但是冬蟲夏草這種奇特的生物性質非常特殊，任何添加都可能會對冬蟲夏草的精華釋放造成影響，為了追求產品的完美效果，他執拗的不願意添加任何輔料。張雪峰對品質的執著打動了那位工程師，那位元老工程師沈吟半晌，終於點點頭，“我們試試吧。”
                </p>
                <p>
                  說幹就幹，為了這個實驗，菲特集合了研發中心裡十餘位頂尖的工程師，與張雪峰和他的團隊共同組成了技術攻堅隊伍。或許這是世界上最昂貴的壓片實驗吧，每批十公斤的冬蟲夏草破膜破壁粉源源不斷寄往德國，然後在實驗中報廢，就連德國菲特的人都感覺實在太可惜。可張雪峰只是沈默，卻依然按時足量寄去比黃金還貴重的冬蟲夏草細胞級微粉，還不時的帶上團隊飛往德國，同菲特的工程師們一起研究，分析成分、掌握特點，討論下一步的實驗方案，菲特的工程師們常常感嘆 —— “你要是在德國，一定是個一流的工程師。”在消耗價值近2000萬的冬蟲夏草細胞級微粉之後，冬蟲夏草純粉片終於誕生了，中德兩方一片歡呼，“中國張”的執著，讓德國人竪起了大拇指。張雪峰的團隊也高興的表示，在同菲特的合作中，從思路到態度都收穫良多。
                </p>
                <div class="clearBoth"></div>
                <br><br><br>
                <div>
                  <h5 class="c-small-title">精益，還要求精</h5>
                  <p class="w_802" >
                    德國 S+S 雙仕公司也領教過張雪峰的這種執著。 2009 年的一天，張雪峰走進雙仕公司的廠部，要求親自試驗雙仕金屬檢測機的效果。雙仕公司的卡門陪著他由低到高幾乎試遍了雙仕所有精度的檢測機，在初始的試驗中，卡門觀察到張雪峰緊鎖的眉頭始終未曾展開。“這是一個超級挑剔的客戶。”卡門直到現在還清晰記得那時他心裡的評價。實驗到雙仕最高精度的一台機器時，卡門陪著張雪峰緊張的盯著那一批冬蟲夏草進入檢測機，直到機器成功的檢測出張雪峰想要的結果，看見張雪峰滿意的笑容，卡門才吐出一直憋著的一口氣。
                  </p>
                  <p class="w_802">
                    不過跟張雪峰的合作可不那麼簡單，很快，張雪峰又提出了兩個要求 —— 第一是把精度進一步提高；第二則是在金屬探測儀的末端加裝分揀裝置，對不合格的原草實施自動淘汰。第一個要求很快解決了，第二個要求本來也挺簡單，用在了冬蟲夏草上卻又產生了難題：由於冬蟲夏草體積小且非常脆，所以分揀裝置的操作必須非常精微，才能精確的進行分揀而不損傷。為了攻克這個難題，張雪峰和他的團隊又一頭紮進了雙仕的實驗基地，和雙仕的研究團隊一起把整個檢驗過程不斷提高和改良……雙仕的工程師直到現在說起來還非常感慨，“從來沒有一個企業的老闆、總設計師會下到我們的基地跟我們一起合作一起研究，更令人欽佩的，還是他對品質毫不讓步的執著。”張雪峰則說，“與雙仕團隊共同研發的這段時間令我們收穫非常大，不僅能夠讓我們的目標完美呈現，更重要的是學習到了雙仕團隊的嚴謹和細緻。”毫無意外，伴隨著張雪峰的執著，他們的研究又成功了。</p>
                  <p class="w_802" >如今，在極草的生產線上，雙仕的金屬探測儀和美國的高精度 X 光機、義大利的水分測定儀從原料源頭對產品品質組成了一道牢不可破的防線，使金屬草、鐵絲草難以魚目混珠，在原料購買、生產到成品等各個環節，保證了產品的純度和安全。</p>
                  <div class="c_box" >
                    <img  src="../../assets/advertisement/zt1-pic6.jpg" alt="">
                    <img src="../../assets/advertisement/zt1-pic7.jpg" alt="" >
                  </div>
                  <br>
                  <div class="clearBoth"></div>
                  <br><br><br>
                  <img class="w_326"  src="../../assets/advertisement/zt1-pic9.jpg" alt="">
                  <div>
                    <h5 class="c-small-title">極草插上德國之翼</h5>
                    <p>
                      事實證明張雪峰的執著是有價值的，插上德國之翼的極草以其卓越的產品力迅速贏得了消費者的認同與追捧，許多消費者一旦嘗試過極草便再難捨棄。短短兩年多，極草已成為整個冬蟲夏草行業的領軍者，開創了一個嶄新的冬蟲夏草高效利用時代。
                    </p>
                    <p>
                      判斷一個人如何，要看他的朋友是誰；判斷一個企業如何，則要看它的合作夥伴是誰，對品質同樣嚴苛的追求，讓三家中德企業之間惺惺相惜。這份高度契合的追求，使三家企業結成了相互信任、共同成長的長久夥伴關係。
                    </p>
                    <p>
                      現在，這一群相互敬重的夥伴又攜手開始了新的研發征程。
                    </p>
                  </div>
                  <div class="clearBoth"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'IntroduceOne',
    data () {
      return {
        scrollTop:0,
        nav:['極草，在澳門','寸草知我心','極草和他的德國夥伴'],
        //保存每一个分类的clientHeight
        listHeight:[],
      }
    },
    methods:{
      /*获取滚动条距离浏览器窗口顶部高度*/
      handleScroll () {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      },
      _calculateHeight(){
        let foodlist = this.$refs.z_zt.getElementsByClassName('heightTOP');
        let height= 0;
        this.listHeight.push(height);
        for( let i=0; i<foodlist.length; i++){
          let item = foodlist[i];
          if (i === 1) {
            height+= 180;
            height+= item.clientHeight;
          }else {

            height+= item.clientHeight;
          }
          this.listHeight.push(height);
        }
      },
      //选择菜单
      selectMenu(index,event){
        let foodList = this.$refs.z_zt.getElementsByClassName('heightTOP');
        let el = foodList[index];
        el.scrollIntoView(true);
      },
/*      // 点击了添加,获取点击对象
      drop(target){
        //体验优化  异步执行下拉动画
        this.$nextTick(()=>{
          this.$refs.shopcart.drop(target)
        })
      }*/
    },
    computed:{
      currentIndex(){
        for(let i=0; i<this.listHeight.length;i++){
          let height1 = this.listHeight[i];
          let height2 = this.listHeight[i+1];
          if(!height2 || this.scrollTop>=height1 && this.scrollTop<height2){
            return i
          }
          if(this.scrollTop >= this.listHeight[2]){
            return 2;
          }
        }
        return 0
      }
    },
    mounted () {
      this._calculateHeight();
      window.addEventListener('scroll', this.handleScroll)
    },
    created(){
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../css/introduce.less";
  .comWidth{
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/pages/advertisement/IntroduceOne.vue